export default __webpack_public_path__ + "static/media/shard-possibilities.51d10710.glb";